import React, { memo, useEffect } from "react";
import { FiEdit, FiTrash2, FiChevronRight } from "react-icons/fi";
import "./AddressCard.css";
import CommonButton from "../../../../components/button/CommonButton";
import CommonInput from "../../../../components/input/CommonInput";
import PhoneInput from "../../../../components/input/PhoneInput";

const AddressCard = ({
  item,
  onEdit,
  onDelete,
  onDeliverHere,
  isSelected,
  onSelect,
  isEditing,
  name,
  setName,
  phoneno,
  setPhoneno,
  countryCode,
  setCountryCode,
  address,
  setAddress,
  country,
  setCountry,
  city,
  setCity,
  state,
  setState,
  pincode,
  setPincode,
  nameError,
  phonenoError,
  addressError,
  countryError,
  cityError,
  stateError,
  pincodeError,
  onPressCountry,
  onSubmitEdit,
  onCancelEdit,
  buttonLoading
}) => {

  const onDeleteAddress = () => {
    onDelete(item);
  };

  const onEditAddress = () => {
    onEdit(item);
  };

  const onPressDeliverHere = () => {
    onDeliverHere(item);
  };

  const handleRadioChange = () => {
    onSelect(item);
  };

  return (
    <div
      className={`address-card-container ${isSelected ? 'address-card-selected' : ''} ${isEditing ? 'address-card-editing' : ''}`}
      onClick={!isEditing ? handleRadioChange : undefined}
    >
      {isEditing ? (
        // Edit Form
        <div className="address-edit-form">
          <div className="form-title">EDIT ADDRESS</div>

          {/* Row 1: Name and Contact */}
          <div className="form-row">
            <div className="form-field">
              <CommonInput
                value={name}
                onChange={setName}
                error={nameError}
                editable={!buttonLoading}
                placeholder="Enter name"
              />
            </div>
            <div className="form-field">
              <PhoneInput
                code={countryCode}
                onChangeCode={(country) => setCountryCode(country.dial_code)}
                onChangeText={setPhoneno}
                value={phoneno}
                placeholder="Enter phone number"
                error={phonenoError}
                className="phone-input-compact"
              />
            </div>
          </div>

          {/* Row 2: Address */}
          <div className="form-row">
            <div className="form-field full-width">
              <CommonInput
                value={address}
                onChange={setAddress}
                error={addressError}
                editable={!buttonLoading}
                placeholder="Enter address"
                multiline={true}
              />
            </div>
          </div>

          {/* Row 3: Country and State */}
          <div className="form-row">
            <div className="form-field">
              <div className="country-container">
                <button
                  className={`country-input-field ${countryError ? "error" : ""
                    }`}
                  onClick={onPressCountry}
                  type="button"
                >
                  <span className={`country-text ${country ? "selected" : ""}`}>
                    {country ? country?.name : "Select country"}
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                {countryError && (
                  <div className="country-error">{countryError}</div>
                )}
              </div>
            </div>
            <div className="form-field">
              <CommonInput
                value={state}
                onChange={setState}
                error={stateError}
                placeholder="Enter state"
                editable={!buttonLoading}
              />
            </div>
          </div>

          {/* Row 4: City and Pincode */}
          <div className="form-row">
            <div className="form-field">
              <CommonInput
                value={city}
                onChange={setCity}
                error={cityError}
                placeholder="Enter city"
                editable={!buttonLoading}
              />
            </div>
            <div className="form-field">
              <CommonInput
                value={pincode}
                onChange={setPincode}
                error={pincodeError}
                editable={!buttonLoading}
                placeholder="Enter pincode"
              />
            </div>
          </div>

          <div className="form-actions">
            <CommonButton
              title={buttonLoading ? "Saving..." : "Save"}
              onPress={onSubmitEdit}
              disabled={buttonLoading}
              customClassName="update-address-button"
            />
            <CommonButton
              title="Cancel"
              onPress={onCancelEdit}
              disabled={buttonLoading}
              customClassName="cancel-edit-button"
              outline={true}
              outlined
            />
          </div>
        </div>
      ) : (
        // Normal Address Display
        <div className="address-card-content">
          <div className="address-card-main-row">
            <div className="address-card-left">
              <div className="address-radio-container">
                <input
                  type="radio"
                  name="address-selection"
                  checked={isSelected}
                  onChange={handleRadioChange}
                  className="address-radio"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div className="address-details">
                <div className="address-name">{item?.name}</div>
                <div className="address-phone">{item?.country_code}{item?.contact}</div>

                <div className="address-lines">
                  <p className="address-line">{item?.address}</p>
                  <p className="address-line">
                    {item?.city}, {item?.state}, {item?.country?.name} - {item?.pincode}
                  </p>
                </div>
              </div>
            </div>

            <div className="address-card-right">
              {!isSelected && (
                <FiChevronRight className="expand-indicator" size={16} />
              )}

              <div className="address-actions">
                <button
                  className="address-edit-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditAddress();
                  }}
                  aria-label="Edit address"
                >
                  <FiEdit size={16} />
                </button>
                <button
                  className="address-delete-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteAddress();
                  }}
                  aria-label="Delete address"
                >
                  <FiTrash2 size={16} />
                </button>
              </div>
            </div>
          </div>

          {isSelected && (
            <div className="address-deliver-section">
              <CommonButton
                title="DELIVER HERE"
                onPress={(e) => {
                  e.stopPropagation();
                  onPressDeliverHere();
                }}
                customClassName="address-deliver-btn"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(AddressCard);
